import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './Component/pages/Header';
import LoginPage from './Component/auth/Login';
import Home from './Component/pages/Home';
import Footer from './Component/pages/Footer';
import PaymentRes from './Payment Getway/PaymentRes';
import ApiDocs from './Component/pages/ApiDocs';
import Contact from './Component/pages/Contact';
import ChatWidget from './Component/pages/ChatWidget';
import DynamicPage from './Component/pages/DynamicPage';
import WelcomeBanner from './Component/pages/WelcomeBanner';


function App() {

  const Location = useLocation();

  const IsHidden = Location.pathname.startsWith("/auth/login");
  const IsApiDocs = Location.pathname.startsWith("/api-docs");

  return (
    <div className='App'>
      {!IsHidden && !IsApiDocs && <WelcomeBanner />}
      {!IsHidden && !IsApiDocs && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/api-docs" element={<ApiDocs />} />
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path='/payment-response' element={<PaymentRes />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/page/:slug' element={<DynamicPage />} />
      </Routes>
      {!IsHidden && !IsApiDocs && <Footer />}
      <ChatWidget />
    </div>
  );
}

export default App;
